import BoxWrapper from 'blocks/BoxWrapper';
import Breadcrumb from 'components/Breadcrumb';
import ROUTES from 'config/routes-constant';
import AwardTicketProvider from 'context/AwardTicketsProvider';
import BreadcrumbInterface from 'models/breadcrumb/breadcrumb.interface';
import { useState } from 'react';
import Step1 from '../Step1';
import Step2 from '../Step2';
import Step3 from '../Step3';
import Stepper from '../Stepper';

const StepHandler = () => {
  const breadcrumbLinks = [
    { title: 'Dashboard', url: ROUTES.dashboard, active: false },
    { title: 'Services', url: ROUTES.services, active: false },
    { title: 'Book Flight', active: true },
  ] as BreadcrumbInterface[];

  const [step, setStep] = useState(1);

  const goToNextStep = () => setStep(step + 1);

  const goToPrevStep = () => setStep(step - 1);

  return (
    <AwardTicketProvider>
      <BoxWrapper>
        <Breadcrumb links={breadcrumbLinks} />
      </BoxWrapper>

      {step !== 1 && (
        <BoxWrapper>
          <Stepper goToNextStep={goToNextStep} goToPrevStep={goToPrevStep} step={step} />
        </BoxWrapper>
      )}

      <BoxWrapper>
        {step === 1 && <Step1 goToNextStep={goToNextStep} />}
        {step === 2 && <Step2 />}
        {step === 3 && <Step3 />}
      </BoxWrapper>
    </AwardTicketProvider>
  );
};

export default StepHandler;
